<div class="banner">
    <img src="/assets/img/banner/2.jpg" alt="Banner">
</div>
<div class="container-fluid innerPageMenu">
    <div class="row">
        <div class="col-md-3">
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>Legal</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active">
                        <a routerLink="/refund-policy">Refund Policy</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="col-md-9">
            <div id="acom">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="inner-card">
                                <h4 class="card-title">Refund Policy</h4>
                                <div class="card-body text-justify">
                                    <p class="lead text-justify inner-lead">If Maharana Pratap Public School receives any refund request
                                        from the user within 4 hours of the transaction, Maharana Pratap Public School will initiate the
                                        refund process within the next 72 hours (3 working days), on the basis of the
                                        User information already made available to Maharana Pratap Public School. Such refund will be
                                        processed after deduction of handling charges / out of pocket and administrative
                                        expenses.
                                    </p>
                                    <p class="lead text-justify inner-lead">Maharana Pratap Public School will, on best effort basis,
                                        provide remittance details to enable the User to take up queries if any, with
                                        the institution. The user is advised to retain remittance details
                                        for any future correspondence with the institution & their bankers.
                                    </p>

                                </div>
                            </div>

                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</div>